import { render, staticRenderFns } from "./EnquiryDetailsPage.vue?vue&type=template&id=6bc98e57&scoped=true&"
import script from "./EnquiryDetailsPage.vue?vue&type=script&lang=js&"
export * from "./EnquiryDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./EnquiryDetailsPage.vue?vue&type=style&index=0&id=6bc98e57&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc98e57",
  null
  
)

export default component.exports